/**
 * Per-child selector rendered as pills. Includes an "add child" pill that opens
 * the add-child dialog (parents / `children` scope only).
 */
import { useState } from 'react';
import { ageFromBirthDate } from '@solandia/core';
import { useI18n } from '../i18n';
import { useFamily } from '../family/FamilyContext';
import { canAccess } from '@solandia/core';
import { AddChildDialog } from '../modules/children/AddChildDialog';

export function ChildrenSwitcher() {
  const { t } = useI18n();
  const { children, activeChild, setActiveChild, membership, reloadChildren } =
    useFamily();
  const [adding, setAdding] = useState(false);
  const canManageChildren = canAccess(membership, 'children');
  const now = new Date();

  return (
    <nav aria-label={t.children.title}>
      <ul className="pills">
        {children.map((c) => {
          const selected = activeChild?.id === c.id;
          return (
            <li key={c.id}>
              <button
                type="button"
                className="pill"
                aria-pressed={selected}
                onClick={() => setActiveChild(c.id)}
              >
                <span className="pill-emoji" aria-hidden="true">
                  {c.avatarEmoji}
                </span>
                <span>{c.name}</span>
                <span className="muted text-xs">
                  {ageFromBirthDate(c.birthDate, now)} {t.children.ageYears}
                </span>
              </button>
            </li>
          );
        })}
        {canManageChildren ? (
          <li>
            <button
              type="button"
              className="pill"
              onClick={() => setAdding(true)}
            >
              <span aria-hidden="true">＋</span> {t.children.add}
            </button>
          </li>
        ) : null}
      </ul>

      {adding ? (
        <AddChildDialog
          onClose={() => setAdding(false)}
          onCreated={() => {
            setAdding(false);
            reloadChildren();
          }}
        />
      ) : null}
    </nav>
  );
}
